module.exports = __webpack_public_path__ + "img/Avatar-4.6ac3af89.svg";